import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

export const useAdMediaQuery = () => {
  const theme = useTheme();
  const landscape = useMediaQuery(theme.breakpoints.up("md"));

  return [landscape];
};
